import React from "react"

import Style from "./footer.module.scss"

/**
 * Footer (default): Footer that is either an editorial signature
 * and mailing list blurb, or an article writer's bio
 */
const Footer = props => {
  if (props.contentType === "Editorial") {
    return <EditorialFooter content={props.content} />
  } else if (props.contentType === "Article") {
    return <ArticleFooter content={props.content} headshots={props.headshots} />
  }
}

export default Footer

/* ===================================================*/

/**
 * EditorialFooter: Footer for the letter from the editor, including
 * Name, Position, and Wet Ink newsletter blurb
 */
const EditorialFooter = props => {
  return (
    <footer>
      <div className={Style.signature}>
        {props.content}
        <br />
      </div>
      <div className={Style.mailingList}>
        <hr />
        <br />
        Want to stay informed about new issues of Archive and upcoming Wet Ink
        events? <br />
        <a
          href="http://eepurl.com/de-VZP"
          target={"_blank"}
          rel="noopener noreferrer"
          style={{ color: "#ECD9D5" }}
        >
          <u>Sign up for our mailing list!</u>
        </a>
      </div>
      <br />
    </footer>
  )
}

const ArticleFooter = props => {
  const bios = props.headshots.map((headshot, index) => (
    <div key={index}>
      <img
        src={"http:" + props.headshots[index].file.url}
        className={Style.bioHeadshot}
        alt={"Writer headshot"}
      />
      {props.content[index]}
      <br />
    </div>
  ))
  return (
    <>
      <br />
      <hr />
      {bios}
      <br />
    </>
  )
}
